
















































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';
// import exhibitionM, {
//   Exhibition, Offline, OfflineMap, BoothV2,
// } from '@/modules/exhibitor/exhibition';

import {
  Exhibition,
  Offline,
  OfflineMap,
  BoothV2,
  exhibition as exhibitionM,
  // Exhibition,
  calender,
  Option,
  options,
} from 'mostra';

import { v4 } from 'uuid';

const generateListKey = () => v4();

export type DataType = {
  // isLoading: boolean;
  // owner: string | null;
  // exhibition: Exhibition | null;
  templateTypes: { value: number, text: string }[];
  topTemplateTypes: { value: number, text: string }[];
  publishTypes: { value: number, text: string }[];
  boothTypes: { value: number, text: string }[];
  closeTypes: { value: number, text: string }[];
  titleFontOptions: Option;
  bodyFontOptions: Option;
  footerFontOptions: Option;
  carouselTypeOptions: Option;
  boothV2Type: number;
};

type OfflineItem = {
  id: string,
  offline: Offline,
}

type OfflineMapItem = {
  id: string,
  map: OfflineMap,
}

type BoothV2Item = {
  id: string,
  boothV2: BoothV2,
}

export default Vue.extend({
  name: 'admin-admin-exhibition-modify',
  data(): DataType {
    return {
      // isLoading: true,
      // exhibition: null,
      // owner: null,
      templateTypes: [
        { value: 1, text: 'タイプ1' },
      ],
      topTemplateTypes: [
        { value: 1, text: 'タイプ1' },
        { value: 2, text: 'タイプ2' },
        { value: 3, text: 'タイプ3' },
      ],
      publishTypes: [
        { value: 1, text: '公開' },
        { value: 2, text: 'ティーザー公開' },
        { value: 99, text: '非公開' },
      ],
      boothTypes: [
        { value: 1, text: 'タイプ1' },
        { value: 2, text: 'タイプ2' },
      ],
      closeTypes: [
        { value: 1, text: 'OLD' },
        { value: 2, text: 'NEW' },
      ],
      titleFontOptions: options.titleFontOptions,
      bodyFontOptions: options.bodyFontOptions,
      footerFontOptions: options.bodyFontOptions,
      carouselTypeOptions: options.carouselType,
      boothV2Type: 2,
    };
  },
  props: {
    exhibition: {
      type: Object as PropType<Exhibition>,
      required: true,
    },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
  },
  computed: {
    offlines: {
      get(): OfflineItem[] {
        const ls = [];
        if (!this.exhibition) return [];
        for (const o of this.exhibition.data.offlines) {
          console.log(o);
          ls.push({
            id: generateListKey(),
            offline: o,
          });
        }
        return ls;
      },
      set(val: OfflineItem[]) {
        if (this.exhibition) {
          this.exhibition.data.offlines = val.map((o) => o.offline);
        }
      },
    },
    offlineMaps: {
      get(): OfflineMapItem[][] {
        const ls = [];
        if (!this.exhibition) return [[]];
        for (const o of this.exhibition.data.offlines) {
          const maps = [];
          for (const m of o.maps) {
            // console.log({ m: m });
            maps.push({
              id: generateListKey(),
              map: m,
            });
          }
          ls.push(maps);
        }
        // console.log({ls: ls})
        return ls;
      },
      set(val: OfflineMapItem[][]) {
        if (this.exhibition) {
          val.forEach((offlineMaps, i) => {
            if (this.exhibition) {
              this.exhibition.data.offlines[i].maps = offlineMaps.map((m) => m.map);
            }
          });
        }
      },
    },
    boothsV2: {
      get(): BoothV2Item[] {
        const ls = [];
        if (!this.exhibition) return [];
        for (const boothV2 of this.exhibition.data.boothsV2) {
          console.log(boothV2);
          ls.push({
            id: generateListKey(),
            boothV2: boothV2,
          });
        }
        return ls;
      },
      set(val: BoothV2Item[]) {
        if (this.exhibition) {
          this.exhibition.data.boothsV2 = val.map((o) => o.boothV2);
        }
      },
    },
    booths: {
      get(): string {
        if (this.exhibition) {
          return this.exhibition.data.booths.join('\n');
        } else {
          return '';
        }
      },
      set(value: string) {
        const ls = value
          .split('\n')
          .map((l) => l.replace('\t', '').trim())
          .filter((l) => l.length > 0);

        if (this.exhibition) {
          this.exhibition.data.booths = ls;
        }
      },
    },
    fromOpenDateHours: {
      get(): string {
        if (this.exhibition) {
          const dt = calender.toDate(this.exhibition.data.fromOpenDate);
          return dt.getHours().toString();
        } else {
          return '';
        }
      },
      set(value: string) {
        const hoursLimitNumber = 23;
        if (this.exhibition && Number(value) <= hoursLimitNumber) {
          const dt = calender.toDate(this.exhibition.data.fromOpenDate);
          dt.setHours(Number(value));
          this.exhibition.data.fromOpenDate = new Date(dt);
        }
      },
    },
    fromOpenDateMinutes: {
      get(): string {
        if (this.exhibition) {
          const dt = calender.toDate(this.exhibition.data.fromOpenDate);
          return dt.getMinutes().toString();
        } else {
          return '';
        }
      },
      set(value: string) {
        const minutesLimitNumber = 59;
        if (this.exhibition && Number(value) <= minutesLimitNumber) {
          const dt = calender.toDate(this.exhibition.data.fromOpenDate);
          dt.setMinutes(Number(value));
          this.exhibition.data.fromOpenDate = new Date(dt);
        }
      },
    },
    toOpenDateHours: {
      get(): string {
        if (this.exhibition) {
          const dt = calender.toDate(this.exhibition.data.toOpenDate);
          return dt.getHours().toString();
        } else {
          return '';
        }
      },
      set(value: string) {
        const hoursLimitNumber = 23;
        if (this.exhibition && Number(value) <= hoursLimitNumber) {
          const dt = calender.toDate(this.exhibition.data.toOpenDate);
          dt.setHours(Number(value));
          this.exhibition.data.toOpenDate = new Date(dt);
        }
      },
    },
    toOpenDateMinutes: {
      get(): string {
        if (this.exhibition) {
          const dt = calender.toDate(this.exhibition.data.toOpenDate);
          return dt.getMinutes().toString();
        } else {
          return '';
        }
      },
      set(value: string) {
        const minutesLimitNumber = 59;
        if (this.exhibition && Number(value) <= minutesLimitNumber) {
          const dt = calender.toDate(this.exhibition.data.toOpenDate);
          dt.setMinutes(Number(value));
          this.exhibition.data.toOpenDate = new Date(dt);
        }
      },
    },
    needsImageOfSP(): boolean {
      if (this.exhibition) {
        return this.exhibition.data.sp.carouselType === 1;
      } else {
        return false;
      }
    },
  },
  methods: {
    // async onClickCheck() {
    //   if (this.$refs && this.$refs.observer) {
    //     await (this.$refs.observer as any).validate();
    //   }
    // },
    // async onClickSave() {
    //   this.$emit('save');
    //   // this.$loading(true);
    //   // try {
    //   //   const uid = this.$auth.uid;
    //   //   console.log(uid);
    //   //   console.log(this.exhibition);
    //   //   if (this.exhibition) {
    //   //     const n = await exhibitionM.save(uid, this.exhibition);
    //   //     if (n && n.id) {
    //   //       this.$router.push({
    //   //         name: 'admin-admin-exhibition-modify',
    //   //         params: {
    //   //           id: n.id,
    //   //         },
    //   //       });
    //   //     }
    //   //   }
    //   //   this.$success('保存しました。');
    //   // } catch (error) {
    //   //   console.log(error);
    //   //   this.$error('保存に失敗しました', error);
    //   // } finally {
    //   //   this.$loading(false);
    //   // }
    // },
    // formatDate(dt: any) {
    //   return calender.formatDate(dt);
    // },
    // formatDateTime(dt: any) {
    //   return calender.formatDateTime(dt);
    // },
    // formatDateHourMinute(dt: any) {
    //   return calender.formatDate(dt) + calender.formatHourMinute(dt);
    // },
    // async fetchData() {
    //   this.$loading(true);
    //   this.isLoading = true;
    //   try {
    //     const id = this.$route.params.id;
    //     if (id === 'new') {
    //       this.owner = this.$route.query.owner as string;
    //       if (!this.owner) {
    //         throw Error('owner is null');
    //       }
    //       this.exhibition = exhibitionM.createNew(this.owner);
    //       if (!this.exhibition) throw new Error('exhibition is null');
    //       this.exhibition.data.boothType = this.boothV2Type;
    //     } else {
    //       const r = await exhibitionM.load(id);
    //       if (!r) throw Error('exhibition is null');
    //       console.log(r);
    //       this.owner = r.data.owner || this.$auth.cid;
    //       // バグだけどとしてあえて入れない
    //       r.data.owner = r.data.owner || '';
    //       this.exhibition = r;
    //     }
    //   } catch (error) {
    //     this.$error('取得に失敗しました。', error);
    //   } finally {
    //     this.$loading(false);
    //     this.isLoading = false;
    //   }
    // },
    addNewBrandInCategory(idx: number): void {
      const n = exhibitionM.createNewBrandCloseInfo();
      if (this.exhibition) {
        this.exhibition.data.closeInfo.categories[idx].brands.push(n);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewCategoryBrand(): void {
      const n = exhibitionM.createNewCategoryBrandCloseInfo();
      if (this.exhibition) {
        this.exhibition.data.closeInfo.categories.push(n);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewLocation(): void {
      const newLocation = exhibitionM.createNewLocation();
      if (this.exhibition) {
        this.exhibition.data.locations.push(newLocation);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewOffline(): void {
      const newOffline = exhibitionM.createNewOffline(v4());
      // newOffline.id = v4();

      if (this.exhibition) {
        // this.offlines.push(newOffline);
        this.exhibition.data.offlines.push(newOffline);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewBoothV2(): void {
      const newBoothV2 = exhibitionM.createNewBoothV2();
      if (this.exhibition) {
        this.exhibition.data.boothsV2.push(newBoothV2);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewMap(index: number): void {
      const newMap = exhibitionM.createNewOfflineMap();
      if (this.exhibition) {
        console.log({ offline: this.exhibition.data.offlines[index] });
        this.exhibition.data.offlines[index].maps.push(newMap);
      } else {
        throw new Error('exhibition is null');
      }
    },
    onDelete(list: string[], index: number): void {
      list.splice(index, 1);
    },
    onUp(list: string[], index: number): void {
      if (index === 0) return;
      const val = list.slice(index, index + 1);
      list.splice(index, 1);
      list.splice(index - 1, 0, val[0]);
    },
    onDown(list: string[], index: number): void {
      if (index >= list.length - 1) return;
      const val = list.slice(index, index + 1);
      list.splice(index, 1);
      list.splice(index + 1, 0, val[0]);
    },
    onChangeTitleFont(val: number) {
      if (this.exhibition) {
        this.exhibition.data.design.title.font = val;
      } else {
        throw new Error('exhibition is null');
      }
    },
    onChangeBodyFont(val: number) {
      if (this.exhibition) {
        this.exhibition.data.design.body.font = val;
      } else {
        throw new Error('exhibition is null');
      }
    },
    onChangeFooterFont(val: number) {
      if (this.exhibition) {
        this.exhibition.data.design.footer.font = val;
      } else {
        throw new Error('exhibition is null');
      }
    },
    formatBoothsForTextarea(val: string[]): string {
      return val.join('\n');
    },
    updateBoothV2(val: string, index: number): void {
      if (this.exhibition) {
        const booths = val
          .split('\n')
          .map((l) => l.replace('\t', '').trim())
          .filter((l) => l.length > 0);
        this.exhibition.data.boothsV2[index].booths = booths;
      }
    },
  },
  // async beforeRouteUpdate(to, from, next) {
  //   next();
  //   await this.fetchData();
  // },
  // async mounted() {
  //   await this.fetchData();
  // },
});
